import {
  EditOutline24Icon,
  ServiceOutline24Icon,
} from "@vygruppen/spor-icon-react";
import { VersionEvent } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/Version";
import { useEffect, useState } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { ActionButton } from "shared/components/feedback/InfoMessage/ActionButtons";
import * as ROUTES from "shared/utils/routes";
import { useDropsRole } from "stores/useDropsRole";

export const useActionButtons = (
  versions: VersionEvent[],
  setModalOpen: (value: boolean) => void,
  isPlannedMaintenance: boolean,
  isInfrastructureEvent: boolean,
  onClose: () => void,
  askConfirmation: boolean,
  setAskConfirmation: (value: boolean) => void,
  isError: boolean,
  isDepublish: boolean,
  infrastructureEventUuid: string,
): ActionButton[] => {
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();

  // Infrastructure event details are only available for operative infrastructure events
  const showDecisionSupport = !isPlannedMaintenance && isInfrastructureEvent;

  const { isVaktlederOrDriftledningen } = useDropsRole();
  const showWriteButtons = isVaktlederOrDriftledningen();

  useEffect(() => {
    setShowSpinner(false);
    setAskConfirmation(false);
  }, [versions.length, isError]);

  const closeEventAction: ActionButton = {
    title: isDepublish ? "Depubliser" : "Friskmeld",
    loading: showSpinner,
    onClick: () => {
      setAskConfirmation(true);
    },
    variant: "primary",
    disabled: isPlannedMaintenance,
  };

  const showDecisionSupportAction: ActionButton = {
    title: "Tiltak",
    loading: showSpinner,
    onClick: () => {
      void navigate(
        generatePath(ROUTES.ALTERNATIVE_TRANSPORT_DECISION_SUPPORT, {
          uuid: infrastructureEventUuid,
        }),
      );
    },
    leftIcon: <ServiceOutline24Icon />,
    variant: "tertiary",
  };

  const changeEventAction: ActionButton = {
    title: "Endre",
    onClick: () => setModalOpen(true),
    leftIcon: <EditOutline24Icon />,
    variant: "tertiary",
  };

  const actionButtons: ActionButton[] = [
    ...(showDecisionSupport ? [showDecisionSupportAction] : []),
    ...(showWriteButtons ? [changeEventAction] : []),
    ...(showWriteButtons ? [closeEventAction] : []),
  ];

  const confirmActionButtons: ActionButton[] = [
    {
      title: isDepublish ? "Ja, depubliser" : "Ja, friskmeld",
      variant: "primary",
      loading: showSpinner,
      onClick: () => {
        setShowSpinner(true);
        onClose();
      },
    },
    {
      title: "Avbryt",
      variant: "tertiary",
      onClick: () => setAskConfirmation(false),
    },
  ];

  if (askConfirmation) {
    return confirmActionButtons;
  }
  return actionButtons;
};
